<template>
  <div class="accordion" id="accordionFondeo">
    <div class="accordion-item opcionFondeo">
      <h2 class="accordion-header" id="headingFondeo">
        <button
          class="accordion-button collapsed btn btn-primary rounded-pill"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseFondeo"
          aria-expanded="false"
          aria-controls="collapseFondeo"
        >
          Fondeo
        </button>
      </h2>
      <div
        id="collapseFondeo"
        class="accordion-collapse collapse"
        aria-labelledby="headingFondeo"
        data-bs-parent="#accordionFondeo"
      >
        <div class="accordion-body">
          <div class="card card-body text-start cabeceraDetalle">
            <span
              class="badge bg-warning text-dark align-self-end montoAjudicado p-3 mb-4"
              >Monto Total Adjudicado
              <span class="montoAjudicadoCifra text-dark">{{
                $filters.MoneyFilter(operacion.totalMontoAdjudicado)
              }}</span></span
            >
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Beneficiario</th>
                  <th scope="col">Concepto</th>
                  <th scope="col" class="text-center">Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="beneficiario in listaBeneficiarios"
                  :key="beneficiario.beneficiario"
                >
                  <th scope="row" style="font-weight: 600;">
                    {{ $filters.CapitalizeFilter(beneficiario.beneficiario) }}
                  </th>
                  <td>
                    {{ $filters.CapitalizeFilter(beneficiario.concepto) }}
                  </td>
                  <td class="text-end pe-3" style="font-weight: 600;">
                    {{ $filters.MoneyFilter(beneficiario.monto) }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" colspan="2">TOTAL</th>
                  <td class="text-end pe-3 fw-bold">
                    {{ $filters.MoneyFilter(montoTotalBeneficiarios) }}
                  </td>
                </tr>
                <tr class="table-secondary">
                  <th scope="row" colspan="2">
                    Monto disponible despues de Fondear
                  </th>
                  <td class="text-end pe-3 fw-bold">
                    {{ $filters.MoneyFilter(montoDisponibleDespFondear) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "DetalleFondeo",

  props: {
    operacion: {},
    listaBeneficiarios: {},
    montoTotalBeneficiarios: 0,
    montoDisponibleDespFondear: 0,
  },
});
</script>
<style scoped>
.texto,
p,
span {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: #302d74;
}

.btn {
  z-index: 10;
  font-weight: 600;
  font-size: 18px;
}
.accordion-item {
  border: none;
}
.montoAjudicadoCifra {
  font-weight: 700;
  margin-left: 10px;
}
.bg-warning {
  background-color: #f9ebc8 !important;
}
</style>
